import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL + "/api/v1";

export interface ExchangeRequest {
  token: string;
  userId: string;
  accountId: string;
}

export interface ExchangeResponse {
  token: string;
  userId: string;
  accountId: string;
}

export const exchangeJoulyToken = async (
  request: ExchangeRequest
): Promise<ExchangeResponse> => {
  return (
    await axios.post<ExchangeResponse>(`${BACKEND_URL}/auth/exchange`, request)
  ).data;
};

export const authAPI = { exchangeJoulyToken };
export default authAPI;
